import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";

import { HttpclientService } from "../../../../shared";
import { Observable, Subject, BehaviorSubject } from "rxjs";

import { wsVPPAdminVisitorSelectorDataParm } from "./wsVPPAdminVisitorSelectorDataParm";
import { wsVPPAdminVisitorSelectorVisitorListParm } from "./wsVPPAdminVisitorSelectorVisitorListParm";
import { VPPAdminVisitorSelectorSelectedVisitorInfo } from "./VPPAdminVisitorSelectorSelectedVisitorInfo";

@Injectable()
export class DataService_visitorselector {
	private SearchRefreshSubject = new BehaviorSubject("");
	SearchRefreshObservable = this.SearchRefreshSubject.asObservable();

	constructor(private http: HttpClient, private httpclientService: HttpclientService) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	Wire Up SearchRefresh Events (IN)
	//
	//-----------------------------------------------------------------------------------------------------
	SearchRefresh(data: any) {
		this.SearchRefreshSubject.next(data);
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	Wire Up Selected Events (OUT)
	//
	//-----------------------------------------------------------------------------------------------------

	//
	//	 Visitor Selected
	//
	private VisitorSelectedSubject = new Subject<any>();

	VisitorSelected(SelectedVisitor: VPPAdminVisitorSelectorSelectedVisitorInfo) {
		this.VisitorSelectedSubject.next(SelectedVisitor);
	}

	onVisitorSelected(): Observable<any> {
		return this.VisitorSelectedSubject.asObservable();
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	VPPAdminVisitorSelectorDataGet
	//
	//-----------------------------------------------------------------------------------------------------
	VPPAdminVisitorSelectorDataGet(parms: wsVPPAdminVisitorSelectorDataParm) {
		var postResult$ = new Subject();
		var url = "Visitor/VPPAdminVisitorSelectorDataGet";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	VPPAdminVisitorSelectorSelectList
	//
	//-----------------------------------------------------------------------------------------------------
	VPPAdminVisitorSelectorSelectList(parms: wsVPPAdminVisitorSelectorVisitorListParm) {
		var postResult$ = new Subject();
		var url = "Visitor/VPPAdminVisitorSelectorSelectList";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	VPPAdminVisitorSelectorGetPhoto
	//
	//-----------------------------------------------------------------------------------------------------
	VPPAdminVisitorSelectorGetPhoto(Visitor_PersonID: number) {
		var postResult$ = new Subject();
		var url = "Visitor/VPPAdminVisitorSelectorGetPhoto";

		var promise$ = this.httpclientService.post(url, Visitor_PersonID);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}
}
